import { LegalPageShell } from '@/pages/legal/LegalPageShell';

const VERSION = '2026-08-02';

export function PrivacyPage() {
  return (
    <LegalPageShell title="Política de Privacidade" version={VERSION}>
      <p>
        Esta política descreve como o Manejai trata dados pessoais, em conformidade com a LGPD (Lei
        13.709/2018).
      </p>
      <h2 className="text-lg font-semibold text-manejai-forest">Dados que coletamos</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>Cadastro: nome, e-mail, telefone, senha (hash)</li>
        <li>Identificação fiscal: CPF/CNPJ, razão social</li>
        <li>Operacionais: animais, eventos, lotes, mídias vinculadas ao rebanho</li>
        <li>Pagamento: processado pelo Stripe</li>
        <li>Segurança: IP, user-agent em logs de auditoria</li>
      </ul>
      <h2 className="text-lg font-semibold text-manejai-forest">Finalidade e base legal</h2>
      <p>
        Prestação do contrato SaaS, faturamento, segurança e, quando aceito separadamente,
        melhoria de modelos de identificação por imagem (consentimento).
      </p>
      <h2 className="text-lg font-semibold text-manejai-forest">Subprocessadores</h2>
      <p>
        DigitalOcean (hospedagem), Stripe (pagamentos), Comtele/Twilio (SMS/WhatsApp), Google
        Firebase (push), Sentry (erros), Roboflow (treino de detector, se ML aceito).
      </p>
      <h2 className="text-lg font-semibold text-manejai-forest">Seus direitos</h2>
      <p>
        Acesso, correção, portabilidade, eliminação e revogação de consentimento: privacidade@manejai.com.br
      </p>
      <h2 className="text-lg font-semibold text-manejai-forest">Retenção</h2>
      <p>
        Conta ativa: vigência do contrato. Após cancelamento: período operacional limitado e prazos
        fiscais aplicáveis. Logs de auditoria: até 24 meses.
      </p>
      <p className="text-xs text-manejai-bark/55">
        Versão completa: docs/legal/politica-de-privacidade-rascunho.md
      </p>
    </LegalPageShell>
  );
}
